
import Vue from 'vue'
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        tipoProduto: {
            id: 0,
            descricao: "",
            idGrandeza: 0,
            idCambio: 0,
            idMarca: 0,
            status: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("produto/tipoProduto/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listTipoProduto = result.data.result;

                return listTipoProduto;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar tipos de produtos: [${ex}]`
            };
        }
    },

    async ListByFilter(_, tipoProdutoFilter) {

        try {
            const result = await Vue.prototype.$spTechApi.post("produto/tipoProduto/list-by-filter", tipoProdutoFilter,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listTipoProduto = result.data.result;

                return listTipoProduto;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar tipos de produtos: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`produto/tipoProduto/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter tipo de produto`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter tipo de produto: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, tipoProdutoRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.post(`produto/tipoProduto/create-update`, tipoProdutoRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro atualizado com sucesso!";

                if (tipoProdutoRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    },

    async AlterarStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`produto/tipoProduto/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Tipo de Produto atualizada com sucesso!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao atualizar o status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao atualizar o status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.marca, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.marca;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
